const namespaced = true

const state = {
  contracts: [],
  contract: {}
}

const getters = {
  contracts: state => state.contracts,
  contract: state => state.contract
}

const mutations = {
  SET_CONTRACTS: (state, contracts) => {
    state.contracts = contracts
  },
  SET_CONTRACT: (state, contract) => {
    state.contract = contract
  }
}

const actions = {
  setContracts: ({ commit }, contracts) => {
    commit('SET_CONTRACTS', contracts)
  },
  setContract: ({ commit }, contract) => {
    commit('SET_CONTRACT', contract)
  }
}

export const contract = {
    namespaced,
    state,
    getters,
    actions,
    mutations
}
